module.exports = __webpack_public_path__ + "static/EPD-lamppost_mobile_tri_Chi_banner_low-637211d0231d8169e6af633d3008063c.png";